// Тарифы на главной между баннерами
export const TARIFF_BETWEEN_BANNERS = {
    testName: 'tariff_card_between_banners',
    variants: {
        ENABLED: 'tariff_card_up',
        DISABLED: 'tariff_card_down',
    },
};

// яндекс поиск
export const YA_SEARCH = {
    testName: 'yasearch',
    variants: {
        enabled: 'included',
        disabled: 'disabled',
    },
};

export const FAQ_REDESIGN = {
    testName: 'faq_redesign',
    variants: {
        FAQ_NEW: 'faq_new',
    },
};

// показывать абонементы
export const SHOW_SEASON_TICKET = {
    testName: 'show_season_ticket',
    variants: {
        SHOW: 'show_season_ticket',
        HIDE: 'do_not_show_season_ticket',
    },
};

// Подключение без визита
export const ONLINE_BUY = {
    testName: 'online_buy',
    variants: {
        ENABLED: 'online_buy_enable',
        DISABLED: 'online_buy_disable',
    },
};

